module.exports = __webpack_public_path__ + "img/tit_news.655aedaf.jpg";